import Api from 'fou-api'
import ApiSettings from 'fou-api/definitions/Settings'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'

export default {
  namespaced: true,

  state () {
    return {
      foundrySettings: {}
    }
  },

  getters: {
    settings: state => {
      return ApiSettings.build(state.foundrySettings)
    }
  },

  mutations: {
    set (state, settings = {}) {
      state.foundrySettings = settings
    },
    clear (state) {
      state.foundrySettings = {}
    }
  },

  actions: {
    get ({ dispatch, commit }, options) {
      return new Promise((resolve, reject) => {
        Api.Settings.getSettings()
          .then((response) => {
            if (response.data) {
              commit('set', response.data)
            }
            resolve()
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    update ({ commit }, settings = {}) {
      return new Promise((resolve, reject) => {
        Api.Settings.updateSettings(settings)
          .then((response) => {
            if (response.data.success === true) {
              commit('set', response.data.settings)
            }
            resolve()
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
